// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"320":"2daacf01","510":"1d71abc9","832":"5c2e0169"}[chunkId] + ".chunk.js";
};